import apiSlice from "../../apiSlice";

export const leaveApi = apiSlice.injectEndpoints({
    endpoints: builder => ({
        LeavesList: builder.query({
            query: () => ({ url: '/leaves' }),
            providesTags: ["leave"],
        }),
        Approve: builder.mutation({
            query: (payload) => ({
                url: `leaves/${payload.id}/approve/`,
                method: 'POST',
                body: {}
            }),
            invalidatesTags: ["leave"]
        }),
        Reject: builder.mutation({
            query: (payload) => ({
                url: `leaves/${payload.id}/reject/`,
                method: 'POST',
                body: {}
            }),
            invalidatesTags: ["leave"]
        }),
        myLeavesList: builder.query({
            query: () => ({ url: '/leaves/my/' }),
            providesTags: ["leave"]
        }),
        applyLeave: builder.mutation({
            query: (payload) => ({
                url: 'leaves/',
                method: 'POST',
                body: payload,
            }),
            invalidatesTags: ["leave"]
        }),
    })
});
export const { useApplyLeaveMutation, useMyLeavesListQuery, useLeavesListQuery, useApproveMutation, useRejectMutation } = leaveApi